export default __webpack_public_path__ + "static/media/4.aa013ef1.jpg";